import { StorageAccountView } from "@/modules/storage/account/StorageAccountView.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/_main/storage/account/$accountUuid/")({
    component: Component,
});

function Component() {
    const { accountUuid } = Route.useParams();
    return <StorageAccountView key={accountUuid} accountUuid={accountUuid} />;
}
